import { createNewAppSource } from "api/Appointment";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useCreateSources = () => {
  const queryClient = useQueryClient();
  return useMutation(createNewAppSource, {
    onSuccess: () => {
      queryClient.invalidateQueries('app-sources');
      toast.success("Source Created Successfully");
    },
    onError: () => {
      toast.error(`Something went wrong`);
    },
  });
};
